import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import usePDPGetStockAvailability from 'data-hooks/usePDPGetStockAvailability';
import useProductBasicDetails from 'data-hooks/useProductBasicDetails';
import useProductBasicQueryOptions from 'data-hooks/useProductBasicDetails/useProductBasicQueryOptions';
import { PRODUCT_BASIC_DETAILS } from 'data-hooks/queries';
import useUserData from 'data-hooks/useUserData';
import useStoreDetails from 'hooks/useStoreDetails';
import usePDPCreateProductOptions from './usePDPCreateProductOptions';
import usePDPRedirectDoubleQuery from '../usePDPRedirectDoubleQuery';
const usePDPCreateContextValue = (t0, t1) => {
  const $ = _c(40);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    isEditOrder: t3,
    isQuickView: t4,
    pdpIsModularBYOProduct: t5,
    pdpVariantSkuOverride: t6,
    productOptions: initialProductOptions,
    productBasicDetails: initialProductBasicDetails,
    isServerTitleResolved: t7
  } = t2;
  const isEditOrder = t3 === undefined ? false : t3;
  const isQuickView = t4 === undefined ? false : t4;
  const pdpIsModularBYOProduct = t5 === undefined ? false : t5;
  const pdpVariantSkuOverride = t6 === undefined ? null : t6;
  const isServerTitleResolved = t7 === undefined ? false : t7;
  let t8;
  if ($[2] !== t1) {
    t8 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const {
    skip: t9
  } = t8;
  const skip = t9 === undefined ? false : t9;
  usePDPRedirectDoubleQuery();
  const seededBasicDetails = initialProductBasicDetails?.basicDetails ?? null;
  const hasSeededBasicDetails = !!seededBasicDetails;
  const t10 = skip || hasSeededBasicDetails;
  let t11;
  if ($[4] !== t10) {
    t11 = {
      skip: t10
    };
    $[4] = t10;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const suspenseBasicDetails = useProductBasicDetails(null, slug, undefined, t11);
  const {
    isLoggedIn
  } = useUserData();
  const storeDetails = useStoreDetails();
  const isRetailStore = Boolean(storeDetails);
  const shouldRefreshSeededPrice = isLoggedIn || isRetailStore;
  let t12;
  if ($[6] !== shouldRefreshSeededPrice) {
    t12 = shouldRefreshSeededPrice ? {
      fetchPolicy: "cache-and-network"
    } : {};
    $[6] = shouldRefreshSeededPrice;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  const t13 = skip || !hasSeededBasicDetails || !shouldRefreshSeededPrice;
  let t14;
  if ($[8] !== t13) {
    t14 = {
      skip: t13
    };
    $[8] = t13;
    $[9] = t14;
  } else {
    t14 = $[9];
  }
  let t15;
  if ($[10] !== slug || $[11] !== t12 || $[12] !== t14) {
    t15 = {
      id: null,
      slug,
      queryOptions: t12,
      hookOptions: t14
    };
    $[10] = slug;
    $[11] = t12;
    $[12] = t14;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  const loggedInQueryOptions = useProductBasicQueryOptions(t15);
  const {
    data: loggedInBasicDetailsData
  } = useQuery(PRODUCT_BASIC_DETAILS, loggedInQueryOptions);
  let t16;
  if ($[14] !== hasSeededBasicDetails || $[15] !== loggedInBasicDetailsData?.basicDetails || $[16] !== seededBasicDetails || $[17] !== suspenseBasicDetails) {
    t16 = hasSeededBasicDetails ? {
      loading: false,
      error: null,
      data: loggedInBasicDetailsData?.basicDetails ?? seededBasicDetails,
      rawLoading: false,
      rawData: {
        basicDetails: loggedInBasicDetailsData?.basicDetails ?? seededBasicDetails
      },
      refetch: suspenseBasicDetails.refetch
    } : suspenseBasicDetails;
    $[14] = hasSeededBasicDetails;
    $[15] = loggedInBasicDetailsData?.basicDetails;
    $[16] = seededBasicDetails;
    $[17] = suspenseBasicDetails;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const basicDetails = t16;
  const productId = basicDetails?.data?.id || null;
  const t17 = !isQuickView && !isEditOrder;
  let t18;
  if ($[19] !== initialProductOptions || $[20] !== pdpVariantSkuOverride || $[21] !== productId || $[22] !== slug || $[23] !== t17) {
    t18 = {
      id: productId,
      slug,
      pdpVariantSkuOverride,
      shouldUpdateQueryParam: t17,
      initialProductOptions
    };
    $[19] = initialProductOptions;
    $[20] = pdpVariantSkuOverride;
    $[21] = productId;
    $[22] = slug;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== skip) {
    t19 = {
      skip
    };
    $[25] = skip;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  const {
    atoms,
    productOptions
  } = usePDPCreateProductOptions(t18, t19);
  let t20;
  if ($[27] !== basicDetails || $[28] !== productOptions) {
    t20 = {
      basicDetails,
      productOptions
    };
    $[27] = basicDetails;
    $[28] = productOptions;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  const stockAvailability = usePDPGetStockAvailability(t20);
  let t21;
  if ($[30] !== atoms || $[31] !== basicDetails || $[32] !== isServerTitleResolved || $[33] !== pdpIsModularBYOProduct || $[34] !== pdpVariantSkuOverride || $[35] !== productId || $[36] !== productOptions || $[37] !== slug || $[38] !== stockAvailability) {
    t21 = {
      atoms,
      basicDetails,
      isServerTitleResolved,
      id: productId,
      pdpIsModularBYOProduct,
      pdpVariantSkuOverride,
      pdpIsAvailableInSizesOpen: true,
      productOptions,
      stockAvailability,
      slug
    };
    $[30] = atoms;
    $[31] = basicDetails;
    $[32] = isServerTitleResolved;
    $[33] = pdpIsModularBYOProduct;
    $[34] = pdpVariantSkuOverride;
    $[35] = productId;
    $[36] = productOptions;
    $[37] = slug;
    $[38] = stockAvailability;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  return t21;
};
export default usePDPCreateContextValue;